// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:959px){h2[data-v-f5042aee]{margin-bottom:.5rem;font-size:1.25rem;font-weight:700}.list__job[data-v-f5042aee]{width:100%}[data-v-f5042aee] .jc{margin-left:auto;margin-right:auto}}", ""]);
// Exports
module.exports = exports;
